import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ZipsState } from 'types';

export const initialState: ZipsState = {
  loading: false,
  zipsList: [],
  totalCount: 0,
  currentPage: 1,
  pageSize: 10,
  filter: null,
  countryCode: "us",
  reset: false
};

const slice = createSlice({
  name: 'Zip Codes',
  initialState,
  reducers: {
    setZipsList: (state, { payload }: PayloadAction<any>) => {
      state.loading = false;
      state.zipsList = payload || [];
      state.reset = false;
    },
    setTotalCount: (state, { payload }: PayloadAction<any>) => {
      state.totalCount = payload;
    },
    setCurrentPage: (state, { payload }: PayloadAction<any>) => {
      state.currentPage = payload;
    },
    setPageSize: (state, { payload }: PayloadAction<any>) => {
      state.pageSize = payload;
    },
    setFilter: (state, { payload }: PayloadAction<any>) => {
      state.filter = payload;
    },
    setCountry: (state, { payload }: PayloadAction<any>) => {
      state.countryCode = payload;
    },
    reset: (state) => {
      state.reset = true;
    }
  }
});

export const { setZipsList, setTotalCount, setCurrentPage, setPageSize, setFilter, setCountry,reset } =
  slice.actions;

export default slice.reducer;
